import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  artists: hasMany('artist', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  person: belongsTo('person', { inverse: null }),
  sftpUsers: hasMany('sftp-user', { inverse: 'user' }),
  userRoles: hasMany('user-role', { inverse: null }),
});
